module.exports = __webpack_public_path__ + "img/i_icon.d0d8ea6e.png";